import {
  ConceptNode,
  SubjectKey,
  SubjectToConceptData,
} from "../../Concepts.interface";

export const filterTreeBySearch = (
  data: SubjectToConceptData,
  query: string,
): SubjectToConceptData => {
  const searchTerm = query.toLowerCase();

  const filterNode = (node: ConceptNode): ConceptNode | null => {
    const isMatch = node.name.toLowerCase().includes(searchTerm);

    const filteredChildren = node.children
      .map(filterNode)
      .filter((child): child is ConceptNode => child !== null);

    if (isMatch || filteredChildren.length > 0) {
      return {
        ...node,
        children: filteredChildren,
      };
    }

    return null;
  };

  const result: Partial<SubjectToConceptData> = {};

  (Object.keys(data) as SubjectKey[]).forEach((subjectKey) => {
    const subjectRootNode = data[subjectKey];

    const filteredRoot = filterNode(subjectRootNode);

    // If the root has any matches (directly or via children), include it
    if (filteredRoot) {
      result[subjectKey] = filteredRoot;
    }
  });

  return result as SubjectToConceptData;
};
